export default "__VITE_ASSET__wPcMXOL$__"